import React, { useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	FormGroup,
	Form,
	Label,
	Col,
} from 'reactstrap';
import Select from 'react-select';
import Datetime from 'react-datetime';
import { Get, Post, JENIS_DESA, ID_DESA } from '../../../function/Koneksi';


const ModalPenduduk = ({ data, optionData, setAlert, getDataAnggota, isOpen, setIsOpen, statusRefresh, setStatusRefresh, propsData, kiosk }) => {
	const dateFormat = require('dateformat');

	const initFormData = {
        frmKk: optionData.frmKk,
        kkStat: optionData.kkStat,
		frmNik: optionData.frmNik,
        frmShdk: optionData.frmShdk,
        frmAgm: optionData.frmAgm,
        frmPtr: optionData.frmPtr,
        frmPkr: optionData.frmPkr,
        frmStp: optionData.frmStp,
        frmJk: optionData.frmJk,
        frmSpk: optionData.frmSpk,
        frmSkh: optionData.frmSkh,
        frmBansos: optionData.frmBansos,
        frmDisabilitas: optionData.frmDisabilitas,
        frmAsalPenduduk: [ 
            { value: 'inherit', label: 'Luar Desa' }, 
            { value: 'none', label: 'Dalam Desa' },
        ],
        shdkStat: null,
        agmStat: null,
        ptrStat: null,
        pkrStat: null,
        jkStat: null,
        spkStat: null,
        stpStat: null,
        skhStat: null,
        bansosStat: null,
        disabilitasStat: null,
        asalPendudukStat: null,
        wilayah: optionData.wilayah,
        frmPrv: optionData.frmPrv,
        prvStat: optionData.prvStat,
        frmKbkt: optionData.frmKbkt,
        kbktStat: optionData.kbktStat,
        frmKec: optionData.frmKec,
        kecStat: optionData.kecStat,
        frmKlds: optionData.frmKlds,
        kldsStat: optionData.kldsStat,

		detail: [],
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
			frmPreviewDraft: false,
			jenis_form: '',
			jenis_input: '',
            editPenduduk: optionData.status.editPenduduk,
		},
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
		formPasangan: 'none',
		
		// Preview surat
		get_data_surat:[],
		get_jenis_surat: "",
	}

	const [formData, setFormData] = useState(initFormData)
	const [props, setProps] = useState(propsData)
	const [kioskMode, setKioskMode] = useState(kiosk)
	const [dt, setDt] = useState(data ? data : [])
	const [draggable, setDraggable] = useState({
		isDown: false,
		startY: null,
		scrollUp: null,
	})

	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}

		setDt(data ? data : [])
		setFormData(data ? {
			...initFormData,
            frmPrv: optionData.frmPrv,
            frmKbkt: optionData.frmKbkt,
            frmKec: optionData.frmKec,
            frmKlds: optionData.frmKlds,
			shdkStat: optionData.shdkStat,
            agmStat: optionData.agmStat,
            ptrStat: optionData.ptrStat,
            pkrStat: optionData.pkrStat,
            jkStat: optionData.jkStat,
            spkStat: optionData.spkStat,
            stpStat: optionData.stpStat,
            skhStat: optionData.skhStat,
            bansosStat: optionData.bansosStat,
            disabilitasStat: optionData.disabilitasStat,
            asalPendudukStat: optionData.asalPendudukStat,
			status: optionData.status,
		} : initFormData)
	}, [isOpen])

	
	const changeInputText = (e, fld) => {
		setDt({
			...dt,
			[fld]: e.target.value,
		})
	};

    const handleChangeSelect = (e, dtVal, parent) => {
		if(e){
            if(parent === "formData"){
                setFormData({
                    ...formData,
                    [dtVal]: e,
                })
            }
            else{
                setDt({
                    ...dt,
                    [dtVal]: e,
                })
            }
		}
		else{
            if(parent === "formData"){
                setFormData({
                    ...formData,
                    [dtVal]: '',
                })
            }
            else{
                setDt({
                    ...dt,
                    [dtVal]: '',
                })
            }
		}
	};
    const handleChangeSelectAsal = (e, dtVal) => {
		if(e){
            setFormData({
                ...formData,
                [dtVal]: e,
                wilayah: e.value,
            })
		}
		else{
            setFormData({
                ...formData,
                [dtVal]: '',
                wilayah: 'none',
            })
		}
	};

    const gantiTgl = (e) => {
		// e.preventDefault();
        if (typeof e._isValid !== 'undefined') {
            setDt({
                ...dt,
                tanggal_lahir : new Date(e.format('YYYY-MM-DD'))

            })
        }
	};

    const getChild = (e, self, parent, child) => {
        if (e) {
            // setFormData({
            //     ...formData,
            //     status:{
            //         ...formData.select,
            //         select: true,
            //     }
            // })

            setAlert({
                loadingPreview: true
            })
    
            let setValWilayah = changeSelectValue(e, self);

			Get(child + '/' + parent + '/' + e.value + '/list', null, (data) => {
				let frm = [];
				data.results.forEach((dt) => {
					frm.push({ value: dt.id, label: dt.nama });
				});
				switch (child) {
					case 'kab-kota':
                        setFormData({
                            ...formData,
                            frmKbkt: frm, 
                            frmKec: [],
                            frmKlds: [],
                            prvStat: setValWilayah,
                            kbktStat: null,
                            kecStat: null,
                            kldsStat: null,
                            status:{
                                ...formData.status,
                                select: false,
                            }
                        })
                        setAlert({
                            loadingPreview: false
                        })

						break;
					case 'kecamatan':
                        setFormData({
                            ...formData,
                            frmKec: frm, 
                            frmKlds: [],
                            kbktStat: setValWilayah,
                            kecStat: null,
                            kldsStat: null,
                            status:{
                                ...formData.status,
                                select: false,
                            }
                        })
                        setAlert({
                            loadingPreview: false
                        })
                        
						break;
					case 'keldes':
                        setFormData({
                            ...formData,
                            frmKlds: frm, 
                            kecStat: setValWilayah,
                            kldsStat: null,
                            status:{
                                ...formData.status,
                                select: false,
                            }
                        })
                        setAlert({
                            loadingPreview: false
                        })
                        
						break;
					default:
						// no default
						break;
				}
				this.forceUpdate();
			});
		}
        else{
            switch (self) {
				case 'provinsi':
                    setFormData({
                        ...formData,
                        prvStat: null,
                        kbktStat: null, 
                        frmKbkt: [],
                        kecStat: null, 
                        frmKec: [],
                        kldsStat: null,
                        frmKlds: [],
                    })

					break;
				case 'kab-kota':
                    setFormData({
                        ...formData,
                        kbktStat: null, 
                        kecStat: null, 
                        frmKec: [],
                        kldsStat: null,
                        frmKlds: [],
                    })
					break;
				case 'kecamatan':
                    setFormData({
                        ...formData,
                        kecStat: null, 
                        kldsStat: null,
                        frmKlds: [],
                    })

					break;
				case 'keldes':
					setFormData({
                        ...formData,
                        kldsStat: null
                    })
					break;
				default:
					// no default
					break;
			}
        }
	};

    const changeSelectValue = (e, sel) => {
		if (e) {
            setAlert({
                loadingPreview: true
            })

            return e;
		} else {
			switch (sel) {
				case 'provinsi':
                    setFormData({
                        ...formData,
                        prvStat: null,
                        kbktStat: null, 
                        frmKbkt: [],
                        kecStat: null, 
                        frmKec: [],
                        kldsStat: null,
                        frmKlds: [],
                    })

					break;
				case 'kab-kota':
                    setFormData({
                        ...formData,
                        kbktStat: null, 
                        kecStat: null, 
                        frmKec: [],
                        kldsStat: null,
                        frmKlds: [],
                    })
					break;
				case 'kecamatan':
                    setFormData({
                        ...formData,
                        kecStat: null, 
                        kldsStat: null,
                        frmKlds: [],
                    })

					break;
				case 'keldes':
					setFormData({
                        ...formData,
                        kldsStat: null
                    })
					break;
				default:
					// no default
					break;
			}
		}

		this.state.status.select = false;
		this.forceUpdate();
	};

    const handleInputChangeNIK = (e, fld) => {
        if (e) {
            if (fld === 'kk') {
				let param = {
					id: e
				};
				Post('kartu-keluarga/select', null, param, (datakk) => {
					let frmKk = [];
					if (datakk.data.results.data.length > 0) {
						datakk.data.results.data.forEach((dt) => {
							frmKk.push({ value: dt.id, label: dt.nama_kepala_keluarga? dt.id + ' (' + dt.nama_kepala_keluarga.nama + ')' : dt.id });
						});

                        setFormData({
                            ...formData,
                            frmKk: frmKk,
                        })
					} 
				});
			}
        }
    };

	const simpan = (e) => {
		e.preventDefault();
        setAlert({
            loadingPreview: true
        })

        if(formData.status.kartu_keluarga){
            // console.log('proses simpan kartu keluarga anggota')
            let tgl_lahir_anggota = dt.tanggal_lahir?dateFormat(new Date(dt.tanggal_lahir), 'yyyy-mm-dd'):''

            if ( 
                formData.shdkStat &&
                formData.agmStat &&
                formData.ptrStat &&
                formData.pkrStat &&
                formData.jkStat &&
                formData.spkStat &&
                formData.stpStat &&
                formData.skhStat &&
                formData.bansosStat &&
                formData.disabilitasStat
            ) {
                if(tgl_lahir_anggota){
                    Get('penduduk/find', dt.idbaru, (data) => {
                        if (data.results !== null) {
                            setAlert({
                                loadingPreview: false
                            })
                            const alertData = {
                                show: true,
                                basicType: "info",
                                basicTitle: 'Anggota Keluarga',
                                pesanAlert: "NIK penduduk sudah digunakan, silahkan cek kembali NIK anda",
                                successAlert: true,
                            }
                            setAlert(alertData)
                        } else {
        
                            let addPenduduk = {
                                id: dt.idbaru,
                                nama: dt.nama,
                                tempat_lahir: dt.tempat_lahir,
                                tanggal_lahir: tgl_lahir_anggota,
                                jk: formData.jkStat.value,
                                shdk: formData.shdkStat.value,
                                agama: formData.agmStat.value,
                                status_perkawinan: formData.spkStat.value,
                                status_kehidupan: formData.skhStat.value,
                                bansos: formData.bansosStat.value,
                                disabilitas: formData.disabilitasStat.value,
                                pendidikan_terakhir: formData.ptrStat.value,
                                pekerjaan: formData.pkrStat.value,
                                nama_ibu_kandung: dt.nama_ibu_kandung,
                                nama_ayah_kandung: dt.nama_ayah_kandung,
                                status_penduduk: formData.stpStat.value,
                                pkrStat: formData.pkrStat,
                                shdkStat: formData.shdkStat,
                            };
    
                            setDt({
                                ...dt,
                                idbaru: '',
                                nama: '',
                                tempat_lahir: '',
                                nama_ayah_kandung: '',
                                nama_ibu_kandung: '',
                                tanggal_lahir: '',
                            })
                            setFormData({
                                ...formData,
                                shdkStat: null,
                                agmStat: null,
                                ptrStat: null,
                                pkrStat: null,
                                jkStat: null,
                                spkStat: null,
                                stpStat: null,
                                skhStat: null,
                                bansosStat: null,
                                disabilitasStat: null,
                            })
                            getDataAnggota(addPenduduk)
                        }
                    })
                }
                else{
                    const alertData = {
                        show: true,
                        basicType: "info",
                        basicTitle: 'Data Penduduk',
                        pesanAlert:
                            'Data tanggal lahir belum diisi'
                    }
                    setAlert({
                        loadingPreview: false
                    })
                    setAlert(alertData)
                }
            } else {
                const alertData = {
                    show: true,
                    basicType: "info",
                    basicTitle: 'Data Penduduk',
                    pesanAlert:
                        'Data belum lengkap. Mohon Pastikan data SHDK, Agama, Pendidikan Terakhir, Pekerjaan, Status Perkawinan, Status Penduduk, Jenis Kelamin, Status Bansos dan Status Disabilitas sudah dipilih'
                }
                setAlert({
                    loadingPreview: false
                })
                setAlert(alertData)
            }
        }
        else{
            let tgl_lahir = dt.tanggal_lahir?dateFormat(new Date(dt.tanggal_lahir), 'yyyy-mm-dd'):''
            if ( 
                ((formData.kldsStat && formData.wilayah === 'inherit') || formData.wilayah === 'none') &&
                formData.kkStat &&
                formData.shdkStat &&
                formData.agmStat &&
                formData.ptrStat &&
                formData.pkrStat &&
                formData.jkStat &&
                formData.spkStat &&
                formData.stpStat &&
                formData.skhStat &&
                formData.bansosStat &&
                formData.disabilitasStat &&
                formData.kkStat !== null
            ) {
                if(tgl_lahir){
                    let id = dt.id;
                    if(formData.status.kartu_keluarga_tambah_penduduk){
                        id = 0;
                    }

                    let addPenduduk = {
                        id: dt.idbaru,
                        id_kk: formData.status.editPenduduk && formData.status.kartu_keluarga_tambah_penduduk === false? dt.id_kk : formData.kkStat.value,
                        id_keldes: formData.wilayah === "inherit" ? formData.kldsStat.value : ID_DESA,
                        nama: dt.nama,
                        alamat: dt.alamat,
                        tempat_lahir: dt.tempat_lahir,
                        tanggal_lahir: tgl_lahir,
                        jk: formData.jkStat.value,
                        shdk: formData.shdkStat.value,
                        agama: formData.agmStat.value,
                        status_perkawinan: formData.spkStat.value,
                        status_kehidupan: formData.skhStat.value,
                        bansos: formData.bansosStat.value,
                        disabilitas: formData.disabilitasStat.value,
                        pendidikan_terakhir: formData.ptrStat.value,
                        pekerjaan: formData.pkrStat.value,
                        nama_ibu_kandung: dt.nama_ibu_kandung,
                        nama_ayah_kandung: dt.nama_ayah_kandung,
                        status_penduduk: formData.stpStat.value
                    };
        
                    let psn = '';
                    let resstat = 204;
                    let metode = 'create';
                    if (id === 0) {
                        psn = 'Tambah';
                        resstat = 201;
                        id = null;
                    } else {
                        psn = 'Ubah';
                        resstat = 200;
                        metode = 'update';
                    }
                    
                    Post('penduduk/' + metode, id, addPenduduk, (res) => {
        
                        setAlert({
                            loadingPreview: false
                        })
        
                        if (res.status === resstat) {
                            const alertData = {
                                show: true,
                                basicType: "success",
                                basicTitle: "Data Penduduk",
                                pesanAlert: "Berhasil " + psn + " Data",
                                successAlert: true,
                            }
                            setAlert(alertData)
        
                            setFormData({
                                ...formData,
                                status: {
                                    ...formData.status,
                                    btnForm: false,
                                    form: false,
                                }
                            })
                            setIsOpen(false)
        
                        } else if (res.status === 422) {
                            const alertData = {
                                show: true,
                                basicType: "info",
                                basicTitle: 'Data Penduduk',
                                pesanAlert: res.data.message
                            }
                            setAlert(alertData)
                        } else {
                            const alertData = {
                                show: true,
                                basicType: "info",
                                basicTitle: 'Data Penduduk',
                                pesanAlert: 'Gagal ' + psn + ' Data'
                            }
                            setAlert(alertData)
                        }
                    });
                }
                else{
                    const alertData = {
                        show: true,
                        basicType: "info",
                        basicTitle: 'Data Penduduk',
                        pesanAlert:
                            'Data tanggal lahir belum diisi'
                    }
                    setAlert({
                        loadingPreview: false
                    })
                    setAlert(alertData)
                }
            } else {
                let luar = '';
                if (formData.wilayah === 'inherit') {
                    luar = 'Kelurahan/' + JENIS_DESA + ', ';
                }
                const alertData = {
                    show: true,
                    basicType: "info",
                    basicTitle: 'Data Penduduk',
                    pesanAlert:
                        'Data belum lengkap. Mohon Pastikan data ' +
                        luar +
                        'Nomor KK, SHDK, Agama, Pendidikan Terakhir, Pekerjaan, Status Perkawinan, Status Penduduk dan Jenis Kelamin sudah dipilih'
                }
                setAlert({
                    loadingPreview: false
                })
                setAlert(alertData)
            }
        }
	};

	return (
		<Modal
			classNames={{ overlay: 'card-scrollable' }}
			open={isOpen}
			onClose={() => {
				setIsOpen(false)
			}}
			closeOnEsc={false}
			closeOnOverlayClick={false}
			style={{
				maxwidth: 'unset'
			}}
		>
			<Form
				id="modalForm"
				data-testid="form-create"
				className="theme-form"
				onSubmit={simpan}
			>
				<div
					onMouseDown={(e) => {
						let slider = document.querySelector('.card-scrollable');
						setDraggable({
							isDown: true,
							startY: e.pageY - slider.offsetTop,
							scrollUp: slider.scrollTop,
						})
					}}
					onMouseLeave={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseUp={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseMove={(e) => {
						e.preventDefault();

						let slider = document.querySelector('.card-scrollable');

						if (!draggable.isDown) {
							return;
						}

						const y = e.pageY - slider.offsetTop;
						const startY = draggable.startY;
						const walk = y - startY;
						slider.scrollTop = draggable.scrollUp - walk;
					}}
				>
				<div className="modal-header">
					<h5 className="modal-title">{dt.id == '' || formData.kkStat === null|| formData.status.kartu_keluarga_tambah_penduduk ? 'Tambah' : 'Edit'} Data Penduduk</h5>
				</div>
				<div className="modal-body">
                    <p>
                        Alamat pada data penduduk bisa jadi berbeda dengan alamat pada KK jika penduduk ybs
                        sedang berdomisili di {formData.wilayah !== 'none' ? 'luar' : 'dalam'} kota dalam
                        rangka belajar atau bekerja untuk sementara waktu.
                    </p>
					<input
						className="form-control"
						id="uuid"
						type="hidden"
						placeholder=""
						defaultValue={dt.id}
					/>
                    {
                        formData.status.asal_penduduk?
                            <FormGroup className="row">
                                <Label
                                    className="col-sm-3 col-form-label"
                                    htmlFor="inputEmail3"
                                >
                                    Asal Penduduk
                                </Label>
                                <Col sm="9">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <Select
                                                classNamePrefix="select"
                                                onChange={(e) => {
                                                    handleChangeSelectAsal(e, 'asalPendudukStat');
                                                }}
                                                defaultValue={formData.asalPendudukStat}
                                                value={formData.asalPendudukStat}
                                                name="Asal Penduduk"
                                                options={formData.frmAsalPenduduk}
                                                placeholder="Pilih Asal Penduduk"
                                                isClearable
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </FormGroup>
                        : ''
                    }

                    {
                        formData.status.kartu_keluarga
                        ?
                            ''
                        :
                            <div style={{ display: formData.wilayah }}>
                                <div className="form-row">
                                    <Col md="6 mb-2">
                                        <Label htmlFor="validationCustom01">Provinsi</Label>
                                        <Select
                                            isDisabled={formData.status.select}
                                            classNamePrefix="select"
                                            onChange={(e) => {
                                                getChild(e, 'provinsi', 'prov', 'kab-kota');
                                            }}
                                            defaultValue={formData.prvStat}
                                            value={formData.prvStat}
                                            name="provinsi"
                                            options={formData.frmPrv}
                                            placeholder="Pilih Provinsi"
                                            isClearable
                                        />
                                    </Col>
                                    <Col md="6 mb-2">
                                        <Label htmlFor="validationCustom02">Kabupaten / Kota</Label>
                                        <Select
                                            isDisabled={formData.status.select}
                                            classNamePrefix="select"
                                            onChange={(e) => {
                                                getChild(e, 'kab-kota', 'kab', 'kecamatan');
                                            }}
                                            defaultValue={formData.kbktStat}
                                            value={formData.kbktStat}
                                            name="kabkota"
                                            options={formData.frmKbkt}
                                            placeholder="Pilih Kabupaten/Kota"
                                            isClearable
                                        />
                                    </Col>
                                </div>
                                <div className="form-row">
                                    <Col md="6 mb-3">
                                        <Label htmlFor="validationCustom03">Kecamatan</Label>
                                        <Select
                                            isDisabled={formData.status.select}
                                            classNamePrefix="select"
                                            onChange={(e) => {
                                                getChild(e, 'kecamatan', 'kec', 'keldes');
                                            }}
                                            defaultValue={formData.kecStat}
                                            value={formData.kecStat}
                                            name="kecamatan"
                                            options={formData.frmKec}
                                            placeholder="Pilih Kecamatan"
                                            isClearable
                                        />
                                    </Col>
                                    <Col md="6 mb-3">
                                        <Label htmlFor="validationCustom04">
                                            {formData.isKelurahan?'Kelurahan':JENIS_DESA}
                                        </Label>
                                        <Select
                                            isDisabled={formData.status.select}
                                            classNamePrefix="select"
                                            onChange={(e) => {
                                                handleChangeSelect(e, 'kldsStat','formData');
                                            }}
                                            defaultValue={formData.kldsStat}
                                            value={formData.kldsStat}
                                            name="keldes"
                                            options={formData.frmKlds}
                                            placeholder={formData.isKelurahan?'Pilih Kelurahan':'Pilih Kelurahan/' + JENIS_DESA}
                                            isClearable
                                        />
                                    </Col>
                                </div>
                            </div>
                    }
                    <div className="form-row">
                        {
                            formData.status.kartu_keluarga?
                            ''
                            :
                                formData.status.editPenduduk
                                ?
                                    <Col md="6 mb-3">
                                        <Label htmlFor="validationCustom05">Nomor KK</Label>
                                        <input
                                            className="form-control"
                                            id="no_kk"
                                            type="text"
                                            inputmode="numeric"
                                            pattern="[0-9\s]{16,16}"
                                            minlength="16"
                                            maxlength="16"
                                            placeholder="No. KK"
                                            defaultValue={formData.kkStat?formData.kkStat.label:''}
                                            required
                                            readOnly
                                        />
                                    </Col>
                                :
                                    <Col md="6 mb-3">
                                        <Label htmlFor="validationCustom05">Nomor KK</Label>
                                        <Select
                                            id="noKKPenduduk"
                                            // isDisabled={formData.status.select}
                                            classNamePrefix="select"
                                            onChange={(e) => {
                                                handleChangeSelect(e, 'kkStat','formData');
                                            }}
                                            defaultValue={formData.kkStat}
                                            value={formData.kkStat}
                                            name="No KK"
                                            options={formData.frmKk}
                                            placeholder="Pilih KK"
                                            onInputChange={(e) => handleInputChangeNIK(e, 'kk')}
                                            isClearable
                                        />
                                    </Col>
                        }
                        <Col md="6 mb-3">
                            <Label htmlFor="validationCustom02">NIK</Label>
                            <input
                                className="form-control"
                                id="idbaru"
                                type="text"
                                inputmode="numeric"
                                pattern="[0-9\s]{16,16}"
                                minlength="16"
                                maxlength="16"
                                placeholder="NIK"
                                defaultValue={dt.idbaru}
                                value={dt.idbaru}
                                onChange={e => changeInputText(e, "idbaru")}
                                required
                            />
                        </Col>
                    </div>
                    <div className="form-row">
                        <Col md="8 mb-3">
                            <Label htmlFor="validationCustom05">Nama Lengkap</Label>
                            <input
                                className="form-control"
                                id="nama"
                                type="text"
                                placeholder="Nama Lengkap"
                                defaultValue={dt.nama}
                                value={dt.nama}
                                required
                                onChange={e => changeInputText(e, "nama")}
                            /> 
                        </Col>
                        <Col md="4 mb-3">
                            <Label htmlFor="validationCustom02">SHDK</Label>
                            <Select
                                // isDisabled={formData.status.select}
                                classNamePrefix="select"
                                onChange={(e) => {
                                    handleChangeSelect(e, 'shdkStat','formData');
                                }}
                                defaultValue={formData.shdkStat}
                                value={formData.shdkStat}
                                name="SHDK"
                                options={formData.frmShdk}
                                placeholder="Pilih SHDK"
                                isClearable
                            />
                        </Col>
                    </div>
                    <div className="form-row">
                        <Col md="4 mb-3">
                            <Label htmlFor="validationCustom05">Agama</Label>
                            <Select
                                // isDisabled={formData.status.select}
                                classNamePrefix="select"
                                onChange={(e) => {
                                    handleChangeSelect(e, 'agmStat','formData');
                                }}
                                defaultValue={formData.agmStat}
                                value={formData.agmStat}
                                name="Agama"
                                options={formData.frmAgm}
                                placeholder="Pilih Agama"
                                isClearable
                            />
                        </Col>
                        <Col md="4 mb-3">
                            <Label htmlFor="validationCustom06">Pendidikan Terakhir</Label>
                            <Select
                                // isDisabled={formData.status.select}
                                classNamePrefix="select"
                                onChange={(e) => {
                                    handleChangeSelect(e, 'ptrStat','formData');
                                }}
                                defaultValue={formData.ptrStat}
                                value={formData.ptrStat}
                                name="Pendidikan"
                                options={formData.frmPtr}
                                placeholder="Pilih Pendidikan Terakhir"
                                isClearable
                            />
                        </Col>
                        <Col md="4 mb-3">
                            <Label htmlFor="validationCustom07">Pekerjaan</Label>
                            <Select
                                // isDisabled={formData.status.select}
                                classNamePrefix="select"
                                onChange={(e) => {
                                    handleChangeSelect(e, 'pkrStat','formData');
                                }}
                                defaultValue={formData.pkrStat}
                                value={formData.pkrStat}
                                name="Pekerjaan"
                                options={formData.frmPkr}
                                placeholder="Pilih Pekerjaan"
                                isClearable
                            />
                        </Col>
                    </div>
                    <div className="form-row">
                        <Col md="4 mb-3">
                            <Label htmlFor="validationCustom05">Jenis Kelamin</Label>
                            <Select
                                // isDisabled={formData.status.select}
                                classNamePrefix="select"
                                onChange={(e) => {
                                    handleChangeSelect(e, 'jkStat','formData');
                                }}
                                defaultValue={formData.jkStat}
                                value={formData.jkStat}
                                name="Jenis Kelamin"
                                options={formData.frmJk}
                                placeholder="Pilih Jenis Kelamin"
                                isClearable
                            />
                        </Col>
                        <Col md="4 mb-3">
                            <Label htmlFor="validationCustom02">Tempat Lahir</Label>
                            <input
                                className="form-control"
                                id="tempat_lahir"
                                type="text"
                                placeholder="Tempat Lahir"
                                defaultValue={dt.tempat_lahir}
                                value={dt.tempat_lahir}
                                required
                                onChange={e => changeInputText(e, "tempat_lahir")}
                            />
                        </Col>
                        <Col md="4 mb-3">
                            <Label htmlFor="validationCustom02">Tanggal Lahir</Label>
                            <Datetime
                                locale="id-ID"
                                input={true}
                                timeFormat={false}
                                closeOnTab={true}
                                closeOnSelect={true}
                                dateFormat="DD/MM/yyyy"
                                name="tanggal_lahir"
                                id="tanggal_lahir"
                                initialValue={new Date()}
                                value={dt.tanggal_lahir}
                                onChange={e => {
                                    gantiTgl(e, 'tanggal_lahir')
                                }}
                                inputProps={{ required: true }}
                            />
                        </Col>
                    </div>
                    <div className="form-row">
                        <Col md="6 mb-3">
                            <Label htmlFor="validationCustom05">Status Perkawinan</Label>
                            <Select
                                // isDisabled={formData.status.select}
                                classNamePrefix="select"
                                onChange={(e) => {
                                    handleChangeSelect(e, 'spkStat','formData');
                                }}
                                defaultValue={formData.spkStat}
                                value={formData.spkStat}
                                name="Status Perkawinan"
                                options={formData.frmSpk}
                                placeholder="Pilih Status Perkawinan"
                                isClearable
                            />
                        </Col>
                        <Col md="6 mb-3">
                            <Label htmlFor="validationCustom02">Status Domisili</Label>
                            <Select
                                // isDisabled={formData.status.select}
                                classNamePrefix="select"
                                onChange={(e) => {
                                    handleChangeSelect(e, 'stpStat','formData');
                                }}
                                defaultValue={formData.stpStat}
                                value={formData.stpStat}
                                name="Status Penduduk"
                                options={formData.frmStp}
                                placeholder="Pilih Status Domisili"
                                isClearable
                            />
                        </Col>
                    </div>
                    <div className="form-row">
                        <Col md="6 mb-3">
                            <Label htmlFor="validationCustom05">Nama Ayah Kandung</Label>
                            <input
                                className="form-control"
                                id="nama_ayah_kandung"
                                type="text"
                                placeholder="Nama Ayah Kandung"
                                defaultValue={dt.nama_ayah_kandung}
                                value={dt.nama_ayah_kandung}
                                required
                                onChange={e => changeInputText(e, "nama_ayah_kandung")}
                            />
                        </Col>
                        <Col md="6 mb-3">
                            <Label htmlFor="validationCustom02">Nama Ibu Kandung</Label>
                            <input
                                className="form-control"
                                id="nama_ibu_kandung"
                                type="text"
                                placeholder="Nama Ibu Kandung"
                                defaultValue={dt.nama_ibu_kandung}
                                value={dt.nama_ibu_kandung}
                                required
                                onChange={e => changeInputText(e, "nama_ibu_kandung")}
                            />
                        </Col>
                    </div>
                    <div className="form-row">
                        {
                            formData.status.kartu_keluarga
                            ? ''
                            :
                            <Col md="12 mb-3">
                                <Label htmlFor="validationCustom05">Alamat</Label>
                                <textarea
                                    className="form-control"
                                    id="alamat"
                                    placeholder="Alamat"
                                    defaultValue={dt.alamat}
                                    value={dt.alamat}
                                    required
                                    onChange={e => changeInputText(e, "alamat")}
                                />
                            </Col>
                        }
                        <Col md="4 mb-3">
                            <Label htmlFor="validationCustom02">Status Penduduk</Label>
                            <Select
                                // isDisabled={formData.status.select}
                                classNamePrefix="select"
                                onChange={(e) => {
                                    handleChangeSelect(e, 'skhStat','formData');
                                }}
                                defaultValue={formData.skhStat}
                                value={formData.skhStat}
                                name="Status Penduduk"
                                options={formData.frmSkh}
                                placeholder="Pilih Status Penduduk"
                                isClearable
                            />
                        </Col>
                        <Col md="4 mb-3">
                            <Label htmlFor="validationCustom02">Bantuan Sosial</Label>
                            <Select
                                classNamePrefix="select"
                                onChange={(e) => {
                                    handleChangeSelect(e, 'bansosStat','formData');
                                }}
                                defaultValue={formData.bansosStat}
                                value={formData.bansosStat}
                                name="Status Penduduk"
                                options={formData.frmBansos}
                                placeholder="Pilih Status Bansos"
                                isClearable
                            />
                        </Col>
                        <Col md="4 mb-3">
                            <Label htmlFor="validationCustom02">Disabilitas</Label>
                            <Select
                                classNamePrefix="select"
                                onChange={(e) => {
                                    handleChangeSelect(e, 'disabilitasStat','formData');
                                }}
                                defaultValue={formData.disabilitasStat}
                                value={formData.disabilitasStat}
                                name="Status Penduduk"
                                options={formData.frmDisabilitas}
                                placeholder="Pilih Status Disabilitas"
                                isClearable
                            />
                        </Col>
                    </div>
				</div>
				<div className="modal-footer">
                    {
                        formData.status.kartu_keluarga
                        ?
                            <button
                                type="button"
                                className="btn btn-warning"
                                onClick={() => {
                                    // Tutup modal
                                    setFormData({
                                        ...formData,
                                        status: {
                                            ...formData.status,
                                            form: false,
                                            frmPreviewDraft: false,
                                            jenis_form: '',
                                        }
                                    })
                                    setIsOpen(false)
                                }}
                            >
                                Tutup
                            </button>
                        :
                            <button
                                type="button"
                                className="btn btn-warning"
                                onClick={() => {
                                    // Tutup modal
                                    setFormData({
                                        ...formData,
                                        status: {
                                            ...formData.status,
                                            form: false,
                                            frmPreviewDraft: false,
                                            jenis_form: '',
                                        }
                                    })
                                    setIsOpen(false)
                                }}
                            >
                                Tutup
                            </button>
                    }
					<button
						data-testid="btnSubmitCreate"
						type="submit"
						className="btn btn-primary-custom"
						disabled={formData.status.btnForm}
					>
						Simpan
					</button>
				</div>
				</div>
			</Form>
		</Modal>
	);
}

export default ModalPenduduk;
